import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import HousingPage from './HousingPage'

const TeamHousing = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Housing | ${team.name} | ${guild.name}`}>
      <HousingPage />
    </Section>
  )
}

export default TeamHousing
